import React from 'react'
import Footer from '../components/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
function About() {
    return (
        <>
            <Helmet>
                <title>Spot Your Leads | Verified Real Estate Leads
                </title>
            </Helmet>
            <section className='about'>
                <Container>
                    <div className='pricing-title'>
                        <h2>About us</h2>
                        <h3>Introduction:</h3>
                        <p>
                            At   <span>Spot Your Lead</span> , we redefine how real estate professionals connect with high-quality, verified leads. Our mission is simple: empower you with the tools and resources to find, claim, and close the best opportunities in the market.
                        </p>
                    </div>
                </Container>
            </section>

            <section className="about-section">
                <Container>
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <div className="rightThird">
                                <h3>Who We Are: </h3>
                                <p>
                                    We're a dedicated team of real estate and technology experts who understand the value of actionable leads. By combining industry knowledge with innovative solutions, we've built a platform designed for success.

                                </p>

                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className="imgmob">
                            <img src="images/4.png" alt="about" />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="about-section">
                <Container>
                    <Row>
                        <Col lg={6} md={6} sm={12} className="imgmob">
                            <img src="images/5.png" alt="about" />
                        </Col>
                        <Col lg={6} md={6} sm={12}>
                            <div className="rightThird">
                                <h3>What We Do:</h3>
                                <p>
                                    <span>Spot Your Lead</span> offers premium leads tailored to your specific needs. Whether you're looking for houses, vacant lots, or other property types, our accurate filters and user-friendly interface make the process seamless.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="about-section">
                <Container>
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <div className="rightThird">
                                <h3>Why Choose Us?
                                </h3>
                                <p>
                                    With our commitment to transparency, efficiency, and quality,  <span>Spot Your Lead</span> stands out as the go-to solution for real estate professionals. We don't just provide leads-we help you achieve your business goals.
                                </p>
                                <p>
                                    "Your next big deal is waiting. Ready to get started?"</p>
                                    <Link to="/leads-shop" >

                                <button>Explore Your Leads</button>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className="imgmob">
                            <img src="images/6.png" alt="about" />
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
        </>
    )
}

export default About
